import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-about-our-mission',
  imports: [TranslatePipe],
  templateUrl: './about-our-mission.html',
  styleUrl: './about-our-mission.scss',
})
export class AboutOurMission {}
